import { CookieStorage } from "redux-persist-cookie-storage";
import Cookies from "cookies-js";
//import storageSession from 'redux-persist/lib/storage/session';

const cookiePersistConfig = {
    key: 'sso',
    storage: typeof window !== 'undefined' ? new CookieStorage(Cookies, {
        expiration: {
            'default': 365 * 86400
        }
    }) : null
};


export default cookiePersistConfig;